module.exports = __webpack_public_path__ + "static/media/10CreacionCotizacion-10.e2406619.png";